import { IMAGES } from "@/constants/site";

export const OFFERS = [
  {
    slug: "diagnostic-marketing-strategique",
    imgClass: "scale-110",
    name: "Diagnostic Marketing Stratégique",
    short: "Une vision claire de votre positionnement et un plan d'action priorisé pour repartir sur des bases solides.",
    image: IMAGES.offer1,
    imageAlt: "Documents d'audit de marque, diagnostic concurrentiel et roadmap marketing sur une table de travail — diagnostic marketing stratégique",
    serviceType: "Diagnostic Marketing Stratégique / Audit marketing",
    type: "Mission ponctuelle",
    duration: "3 à 4 semaines",
    price: "Sur devis",
    accroche: "Audit marketing complet & feuille de route claire pour relancer votre croissance.",
    subtitle: "Une vision claire de votre positionnement et un plan d'action priorisé pour relancer votre croissance. Accompagnement sur-mesure sur la Côte d'Azur (et à distance).",
    ctaTitle: "Prêt à faire le point sur votre stratégie ?",
    ctaText: "Réservez un premier échange stratégique de 30 minutes (gratuit et sans engagement). Nous ferons le point sur vos blocages actuels pour vérifier si ce diagnostic est l'étape qu'il vous faut.",
    description: "Une analyse approfondie de votre positionnement et de vos canaux pour repartir sur des bases saines et prioriser vos investissements.",
    keyPoints: [
      "Audit concurrentiel, de marque et de votre discours commercial",
      "Analyse des canaux d'acquisition et du parcours client",
      "Diagnostic rédigé + **Feuille de route opérationnelle à 90 jours**",
      "Session de restitution avec vos équipes + **Suivi par e-mail inclus pendant 30 jours**",
    ],
    audience:
      "Pour les dirigeants de PME et TPE qui investissent dans le marketing sans voir de ROI clair, et les fondateurs de start-ups qui veulent valider des fondations solides avant d'accélérer leurs dépenses.",
    summary:
      "Le Diagnostic Marketing Stratégique est un audit à 360° de votre écosystème marketing : marque, positionnement, canaux, concurrence. En 3 à 4 semaines, vous sortez du pilotage à l'instinct avec des priorités assumées et une feuille de route prête à être déployée.",
    included: [
      "Audit complet de votre marque, votre positionnement et votre discours",
      "Analyse de vos canaux d'acquisition et de votre parcours client",
      "Étude de votre écosystème concurrentiel",
      "Entretiens avec vous et vos équipes",
      "Analyse de vos données et de vos indicateurs existants",
      "Diagnostic rédigé + Feuille de route opérationnelle à 90 jours",
      "Atelier de restitution avec vos équipes",
      "Suivi et assistance par e-mail pendant 30 jours",
    ],
    process: [
      { title: "Cadrage & collecte", text: "Entretien de lancement, accès à vos données, entretiens internes et analyse documentaire." },
      { title: "Analyse & diagnostic", text: "Audit de votre marque, vos canaux, votre parcours client et votre concurrence. Identification des forces, faiblesses et angles morts." },
      { title: "Priorisation", text: "Hiérarchisation des chantiers selon leur impact et leur effort, avec vous, sans jargon." },
      { title: "Restitution", text: "Atelier de restitution et remise de votre feuille de route à 90 jours, actionnable dès le lendemain." },
    ],
    deliverables: [
      "Rapport de diagnostic complet et synthétique",
      "Feuille de route marketing à 90 jours",
      "Plan d'action détaillé avec responsables et échéances",
    ],
    seo: {
      title: "Diagnostic Marketing Stratégique Côte d'Azur | Magali Clouzet",
      description:
        "Audit marketing à 360° pour PME & start-ups sur Nice, Cannes & Sophia Antipolis. Repartez en 3 à 4 semaines avec une feuille de route à 90 jours claire et priorisée.",
    },
  },
  {
    slug: "plan-de-lancement-go-to-market",
    name: "Plan de Lancement & Go-To-Market",
    short: "Sécurisez le lancement de votre produit ou service avec une stratégie structurée, un rétroplanning et des canaux optimisés.",
    image: IMAGES.offer2,
    imageAlt: "Plan de lancement et diagramme de Gantt à l'écran avec carnet d'objectifs — préparation Go-To-Market",
    serviceType: "Plan de Lancement / Go-To-Market",
    type: "Mission projet",
    duration: "6 à 10 semaines",
    price: "Sur devis",
    accroche: "De l'idée au marché : sécurisez et maximisez l'impact de votre produit ou service.",
    subtitle: "Sécurisez et maximisez le lancement de votre produit ou service grâce à une stratégie Go-To-Market structurée, un rétroplanning précis et des canaux d'acquisition ciblés.",
    ctaTitle: "Prêt à réussir le lancement de votre nouvelle offre ?",
    ctaText: "Réservez un premier échange stratégique de 30 minutes (gratuit et sans engagement). Nous analyserons les spécificités de votre projet pour structurer votre mise sur le marché.",
    description: "Une stratégie Go-To-Market complète pour aligner vos messages, vos canaux d'acquisition et vos budgets avant et pendant le lancement.",
    keyPoints: [
      "Positionnement différenciant, promesse de marque et messages clés par cible",
      "Plan d'action multicanal, rétroplanning et budget",
      "Briefs créatifs opérationnels pour vos prestataires (agences, dev, graphistes)",
      "**Accompagnement et ajustement terrain pendant 30 jours post-lancement**",
    ],
    audience:
      "Pour les fondateurs de start-ups qui préparent un lancement stratégique, et les dirigeants de PME qui lancent une nouvelle offre sans vouloir prendre le risque d'un échec d'exécution.",
    summary:
      "Le Plan de Lancement transforme votre mise sur le marché en un plan d'action fluide : positionnement, messages clés, canaux, calendrier et KPIs. En 6 à 10 semaines, votre lancement est sécurisé, vos équipes et prestataires savent exactement quoi faire, et vous maximisez vos chances de succès dès le premier jour.",
    included: [
      "Définition ou affinement de votre positionnement et promesse de marque",
      "Construction de votre matrice de messages par cible",
      "Stratégie Go-To-Market : canaux, séquencement et allocation budgétaire",
      "Calendrier de lancement détaillé",
      "Rédaction des briefs créatifs prêts à l'emploi (pour vos agences, graphistes, dev)",
      "Accompagnement et ajustement terrain pendant 30 jours post-lancement",
    ],
    process: [
      { title: "Immersion", text: "Compréhension fine de votre offre, votre marché, vos cibles et vos contraintes." },
      { title: "Positionnement & message", text: "Ateliers pour verrouiller votre différenciation et un discours qui parle à vos clients." },
      { title: "Stratégie Go-To-Market", text: "Choix des canaux, séquencement des actions, allocation des ressources et du budget." },
      { title: "Plan d'exécution", text: "Calendrier de lancement, répartition des rôles et tableau de bord de pilotage." },
    ],
    deliverables: [
      "Guide de positionnement et socle de messages clés par cible",
      "Stratégie Go-To-Market & Plan multicanal",
      "Rétroplanning de lancement et briefs prestataires",
      "Tableau de bord des indicateurs de succès (KPIs)",
    ],
    seo: {
      title: "Plan de Lancement & Go-To-Market Côte d'Azur | Magali Clouzet",
      description:
        "Stratégie Go-To-Market & plan de lancement sur-mesure pour PME et start-ups (Nice, Sophia Antipolis, Cannes). Sécurisez votre mise sur le marché avec méthode.",
    },
  },
  {
    slug: "direction-marketing-externalisee",
    name: "Direction Marketing Externalisée",
    short: "Un directeur marketing à temps partagé (Fractional CMO) pour piloter votre stratégie et vos équipes au quotidien.",
    image: IMAGES.offer3,
    imageAlt: "Consultante et dirigeant pilotant un tableau de bord marketing — direction marketing externalisée",
    serviceType: "Fractional CMO / Direction Marketing Externalisée",
    duration: "Temps partagé (1 à 2j / sem.)",
    engagement: "Engagement 3 mois renouvelable",
    price: "Sur devis",
    accroche: "Votre bras droit stratégique et opérationnel sans les contraintes d'un recrutement à temps plein.",
    subtitle: "Un directeur marketing senior à temps partagé pour piloter votre stratégie, structurer vos leviers de croissance et encadrer vos équipes au quotidien.",
    ctaTitle: "Prêt à structurer votre pôle marketing ?",
    ctaText: "Réservez un premier échange de 30 minutes (gratuit et sans engagement). Nous étudierons vos enjeux actuels pour définir le rythme d'accompagnement adapté à vos besoins.",
    description: "Je pilote votre stratégie marketing, vos prestataires et vos équipes internes au quotidien avec un regard d'expert dédié.",
    keyPoints: [
      "Comité marketing mensuel (2h), plan d'action priorisé et reporting KPI",
      "Coordination complète de vos prestataires externes, de la stratégie à la livraison",
      "Support continu & réactif (réponse sous 24h et points visio d'urgence)",
      "**Montée en compétences : configuration et intégration des outils IA** pour vos équipes",
    ],
    audience:
      "Pour les dirigeants de PME, start-ups et TPE en croissance qui ont besoin d'une vision stratégique continue et d'un pilotage rigoureux, sans engager la masse salariale d'un directeur marketing permanent.",
    summary:
      "La Direction Marketing Externalisée vous donne accès à une expertise marketing senior à temps partagé (1 à 2 jours par semaine) : pilotage stratégique, coordination des prestataires, priorisation des budgets et suivi des performances. Vous gagnez un bras droit stratégique et opérationnel, sans les coûts fixes ni les risques d'un recrutement à temps plein.",
    included: [
      "Définition, alignement et pilotage de la stratégie marketing globale",
      "Structuration et animation de vos équipes internes",
      "Sélection, brief et coordination de vos agences et prestataires externes",
      "Arbitrage des priorités et gestion optimisée du budget marketing",
      "Reporting régulier et tableaux de bord de performance auprès de la direction",
      "Intégration d'outils et de méthodes innovantes (dont l'IA) pour accélérer l'exécution",
    ],
    process: [
      { title: "Prise de poste", text: "Audit express, rencontre des équipes et des prestataires, compréhension des enjeux business." },
      { title: "Feuille de route", text: "Construction des priorités du trimestre, alignées sur vos objectifs de croissance." },
      { title: "Pilotage continu", text: "Rituels d'équipe, suivi des projets, coordination des prestataires, arbitrages." },
      { title: "Mesure & ajustement", text: "Reporting mensuel, analyse des résultats et réallocation des efforts." },
    ],
    deliverables: [
      "Feuille de route marketing trimestrielle",
      "Rituels de pilotage et tableaux de bord",
      "Comptes rendus de comité de direction",
      "Organisation claire des rôles et des prestataires",
    ],
    seo: {
      title: "Direction Marketing Externalisée Côte d'Azur | Magali Clouzet",
      description:
        "Directeur marketing à temps partagé (Fractional CMO) pour PME sur Nice, Cannes & Sophia Antipolis. Pilotez votre stratégie et vos équipes à coût maîtrisé.",
    },
  },
];
